export const hiddenFiltersList = [
  'ContentType',
  'MathStandards',
  'Subjects',
  'Languages',
];

export const allowedFilterKeys = [
  'grades',
  'numberOfQuestions',
  'questionTypes',
];

export const filtersOpenByDefault = [
  'numberOfQuestions',
  'grades',
];
